import { Alert, Divider } from '@coolblue-development/freddy';
import { useFormatShortDate } from '@coolblue-development/next-formatting-utils/client';
import { useTranslation } from '@i18n/useTranslation';

type Props = {
  expectedReleaseDate: string;
};

function PreOrderNotification({ expectedReleaseDate }: Props) {
  const { t } = useTranslation('webshop.filterPage.storePickup.preOrder');
  const releaseDate = useFormatShortDate(new Date(expectedReleaseDate));

  return (
    <>
      <Alert
        title={t('notificationTitle')}
        description={t('notificationDescription', { releaseDate })}
      />
      <Divider mt={400} mb={400} />
    </>
  );
}

export default PreOrderNotification;
